import axios from "axios";
import API_ENDPOINT from "../config";

export const createCertificateTemplate = async (token, clientId, templateName, templateMeta, templateUrlId, active) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    fd.append("identity", "wmhandler");

    fd.append("clientId", clientId);
    fd.append("templateUrlId", templateUrlId);
    fd.append("templateName", templateName);
    fd.append("templateMeta", JSON.stringify(templateMeta));
    fd.append("active", active);

    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiUrl}Certificate/createCertTemplate`,
        data: fd
    })
}

export const updateCertificateTemplate = async (token, clientId, templateId, templateName, templateMeta, templateThumb, active) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    fd.append("identity", "wmhandler");
    fd.append("clientId", clientId);
    fd.append("templateId", templateId)
    fd.append("templateName", templateName);
    fd.append("templateMeta", JSON.stringify(templateMeta));
    fd.append("templateThumb", templateThumb);
    fd.append("active", active);

    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiUrl}Certificate/updateTemplate`,
        data: fd
    })
}

export const getCertificateTemplates = async (token, clientId) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    // fd.append("clientId", token.id)
    fd.append("identity", "wmhandler");
    fd.append("screenName", "TEMPLATE");
    fd.append("client_id",clientId);

    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiUrl}Certificate/showClient`,
        data: fd
    })
}

export const uploadImageMedia = async (token, clientId, mediaType, certMedia) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    fd.append("identity", "wmhandler");

    fd.append("clientId", clientId);
    fd.append("mediaType", mediaType);
    fd.append("cert_media", certMedia);

    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiUrl}Certificate/uploadCertMedia`,
        data: fd
    })
}

export const getImageMedia = async (token,clientId) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    fd.append("clientId", clientId)
    fd.append("identity", "wmhandler");
    // fd.append("screenName", "TEMPLATE");

    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiUrl}Certificate/getClientMedia`,
        data: fd
    })
}